// BS3-003: cancelled shifts (chargeable late cancellations included) are hidden from the Scheduling Board while "Hide cancelled" is on.
// Same rule as the board API (services/roster/board.py hidden_cancelled) — used by the Day / Month views, which filter client-side.

export const HIDE_CANCELLED_KEY = 'schedulingBoard.hideCancelled';

export function isHiddenCancelled(shift) {
  return String(shift?.status || '').toUpperCase() === 'CANCELLED';   // every cancelled shift, chargeable ones included
}

/** Open Roster: an OPEN / PUBLISHED shift with no worker — same rule as the board API (services/roster/board.py _shift_query). */
export function isOpenRosterShift(shift) {
  const st = String(shift?.status || '').toUpperCase();
  const workers = (shift?.assigned_staff_ids || []).filter(Boolean).length || (shift?.assigned_staff || []).length || (shift?.assigned_staff_id ? 1 : 0);
  return (st === 'OPEN' || st === 'PUBLISHED') && workers === 0;
}

/** Saved choice for this browser; ON when nothing is saved (or storage is unavailable). */
export function readHideCancelled() {
  try {
    const v = window.localStorage.getItem(HIDE_CANCELLED_KEY);
    return v === null ? true : v === '1';
  } catch { return true; }
}

export function saveHideCancelled(on) {
  try { window.localStorage.setItem(HIDE_CANCELLED_KEY, on ? '1' : '0'); } catch { /* private window: keep the default */ }
}
